export default {
    title: "Prodavnice",
    filters: {
        title: 'Filter prodavnica',
        resetAllButton: 'Resetuj sve',
        mobileButton: 'Filteri'
    },
    headerActions: {
        sortFilters: {
            newest: 'Najnovije',
            popularity: 'Najpopularnije'
        },
        search: 'Pretraži',
        stores: 'prodavnica'
    },
}
